import React from 'react';
import { format } from 'date-fns';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrendingUp, FiTrendingDown, FiMinus, FiVolume2 } = FiIcons;

const PriceTable = ({ data, newsData }) => {
  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <h3 className="text-xl font-bold text-gray-800 mb-4">30-Day Price History</h3>
      
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-2 font-semibold">Date</th>
              <th className="text-right py-3 px-2 font-semibold">Price</th>
              <th className="text-right py-3 px-2 font-semibold">Change</th>
              <th className="text-right py-3 px-2 font-semibold">Volume</th>
              <th className="text-center py-3 px-2 font-semibold">News</th>
            </tr>
          </thead>
          <tbody>
            {data.slice().reverse().map((day, index) => {
              const dayNews = newsData.filter(news => news.date === day.date);
              const majorNews = dayNews.filter(news => Math.abs(news.impact) > 0.08);
              
              return (
                <tr key={day.date} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="py-3 px-2">
                    {format(new Date(day.date), 'MMM dd')}
                  </td>
                  <td className="py-3 px-2 text-right font-medium">
                    ${day.price}
                  </td>
                  <td className="py-3 px-2 text-right">
                    <div className={`flex items-center justify-end ${
                      day.change >= 0 ? 'text-green-600' : 'text-red-600'
                    }`}>
                      <SafeIcon 
                        icon={day.change >= 0 ? FiTrendingUp : FiTrendingDown} 
                        className="w-4 h-4 mr-1" 
                      />
                      {(day.change * 100).toFixed(2)}%
                    </div>
                  </td>
                  <td className="py-3 px-2 text-right text-gray-600">
                    <div className="flex items-center justify-end">
                      <SafeIcon icon={FiVolume2} className="w-4 h-4 mr-1" />
                      {(day.volume / 1000000).toFixed(1)}M
                    </div>
                  </td>
                  <td className="py-3 px-2 text-center">
                    <div className="flex items-center justify-center space-x-1">
                      {dayNews.length > 0 && (
                        <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                          {dayNews.length}
                        </span>
                      )}
                      {majorNews.length > 0 && (
                        <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded-full">
                          Major
                        </span>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PriceTable;